import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

/**
 * Default locale of the current market, ignoring the user's language preference.
 * Use it for regional conventions such as 12h/24h clocks, which follow the market,
 * not the language the user reads the app in.
 */
export const useMarketDefaultLocale = (): string => useMarket().locales[0];
